import React from 'react';
import styles from './PlatformButton.module.css';

export default ({ platform, platformURL }) => (
  <a className={styles.link} href={platformURL} target="_blank" rel="noopener noreferrer">
    <img height="14" src={`/platforms/${platform.toLowerCase()}.png`} alt={platform} />
  </a>
);
